import http from '../../services/http/index';
import forResponse from '../../utils/forResponse';
import { LIST_EPAY_PACKAGES_CALENDAR } from '../../constants/apiUrls/apiUrls';


export const getCalendarProducts = () => forResponse(http.get(LIST_EPAY_PACKAGES_CALENDAR, { withCredentials: false }));
